import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Penjualan from "views/admin/report/penjualan";
import Kategori from "views/admin/inventory/kategori";
import Produk from "views/admin/inventory/produk";
import Pelanggan from "views/admin/pelanggan";
import Sales from "views/admin/sales";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
    MdBarChart,
    MdLock,
    MdInsertChart,
    MdDashboard,
    MdShoppingBag,
    MdOutlineStore,
    MdAllInbox,
    MdStickyNote2,
    MdApproval,
} from "react-icons/md";
import { HiTicket } from "react-icons/hi";
import StockList from "views/admin/inventory/stockList";
import HistoryStock from "views/admin/inventory/historyStock";
import TransferStock from "views/admin/inventory/transferStock";
import Inventori from "views/admin/report/inventori";
import Gudang from "views/admin/gudang";
import LabaRugi from "views/admin/report/labaRugi";
import PurchaseOrder from "views/admin/inventory/purchaseOrder";
import TransferStockGudang from "views/admin/inventory/transferStockGudang";
import Promo from "views/admin/promo";
import Transaction from "views/admin/transaction";
import SalesStock from "views/admin/inventory/salesStock";
import SalesCash from "views/admin/report/salesCash";
import GeoLocation from "views/admin/report/geoLocation";
import CreateUser from "views/admin/createUser";
import Absensi from "views/admin/report/absensi";
import KpiSales from "views/admin/kpi-sales";
import DetailKpiSales from "views/admin/detail-kpi-sales";
import KpiCustomer from "views/admin/kpi-customer";
import DetailKpiCustomer from "views/admin/detail-kpi-customer";
import DetailRiwayatStok from "views/admin/detail-riwayat-stok";
import DataUser from "views/admin/data-user";
import LoadingStock from "views/admin/loading-stock";
import KasDeposit from "views/admin/kas-deposit";
import HistoryStockNew from "views/admin/history-stock-new";

const routes = [
    {
        name: "Dashboard",
        layout: "/admin",
        path: "dashboard",
        icon: <MdDashboard className="h-6 w-6" />,
        component: <MainDashboard />,
    },
    {
        name: "Laporan",
        layout: "/admin",
        path: "laporan",
        icon: <MdInsertChart className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Laporan Penjualan",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/penjualan",
                component: <Penjualan />,
            },
            {
                name: "Laporan Laba Rugi",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/laba-rugi",
                component: <LabaRugi />,
            },
            {
                name: "Laporan Inventori",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/inventory",
                component: <Inventori />,
            },
            {
                name: "Laporan Kas Sales",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/kas-sales",
                component: <SalesCash />,
            },
            {
                name: "Laporan Geo Location",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/geo-location",
                component: <GeoLocation />,
            },
            {
                name: "Laporan Absensi",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/absensi",
                component: <Absensi />,
            },
            {
                name: "Laporan KPI Sales",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/kpi-sales",
                component: <KpiSales />,
            },
            {
                name: "Detail Laporan KPI Sales",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/kpi-sales/:id/detail",
                component: <DetailKpiSales />,
            },
            {
                name: "Laporan KPI Pelanggan",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/kpi-customer",
                component: <KpiCustomer />,
            },
            {
                name: "Detail Laporan KPI Pelanggan",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "laporan/kpi-customer/:id/detail",
                component: <DetailKpiCustomer />,
            },
        ]
    },
    {
        name: "Produk",
        layout: "/admin",
        path: "produk",
        icon: <MdShoppingBag className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Kategori Produk",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "produk/kategori",
                component: <Kategori />,
            },
            {
                name: "Daftar Produk",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "produk/list",
                component: <Produk />,
            },
        ]
    },
    {
        name: "Approval",
        layout: "/admin",
        path: "approval",
        icon: <MdApproval className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Loading Stock",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "approval/loading-stock",
                component: <LoadingStock />,
            },
            {
                name: "Setoran Kas",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "approval/setoran-kas",
                component: <KasDeposit />,
            },
        ]
    },
    {
        name: "Inventori",
        layout: "/admin",
        path: "inventori",
        icon: <MdAllInbox className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Daftar Stok",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/daftar-stok",
                component: <StockList />,
            },
            {
                name: "Stok Opname",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/stok-opname",
                component: <TransferStock />,
            },
            {
                name: "Purchase Order",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/purchase-order",
                component: <PurchaseOrder />,
            },
            {
                name: "Transfer Stok Gudang",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/transfer-stok-gudang",
                component: <TransferStockGudang />,
            },
            {
                name: "Riwayat Stok",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/riwayat-stok",
                component: <HistoryStockNew />,
            },
            {
                name: "Detail Riwayat Stok",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/riwayat-stok/detail/:id",
                component: <DetailRiwayatStok />,
            },
            {
                name: "Stok Sales",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "inventori/stok-sales",
                component: <SalesStock />,
            },
        ]
    },
    {
        name: "Sales & Pelanggan",
        layout: "/admin",
        path: "sales-and-customer",
        icon: <MdOutlineStore className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Data Karyawan",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "sales-and-customer/data-karyawan",
                component: <Sales />,
            },
            {
                name: "Data Pelanggan",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "sales-and-customer/data-pelanggan",
                component: <Pelanggan />,
            },
            {
                name: "Data User",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "sales-and-customer/data-user",
                component: <DataUser />,
            },
        ]
    },
    {
        name: "Daftar Gudang",
        layout: "/admin",
        path: "gudang",
        icon: <MdDashboard className="h-6 w-6" />,
        component: <Gudang />,
    },
    {
        name: "Promo",
        layout: "/admin",
        path: "promo",
        icon: <HiTicket className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Daftar Promo",
                layout: "/admin",
                icon: <MdBarChart className="h-6 w-6" />,
                path: "promo/daftar-promo",
                component: <Promo />,
            },
        ]
    },
    {
        name: "Transaksi",
        layout: "/admin",
        path: "transaction",
        icon: <MdStickyNote2 className="h-6 w-6" />,
        component: <MainDashboard />,
        secondary: true,
        child: [
            {
                name: "Daftar Transaksi",
                layout: "/admin",
                icon: <MdStickyNote2 className="h-6 w-6" />,
                path: "transaction/list",
                component: <Transaction />,
            },
        ]
    },
    {
        name: "Sign In",
        layout: "/auth",
        path: "sign-in",
        icon: <MdLock className="h-6 w-6" />,
        component: <SignIn />,
    },
];
export default routes;
